import { Link } from '@tanstack/react-router'

import type { ButtonProps } from '@/components/ui'
import { isCreditsPlan, isTrialPlan, useAccount } from '@/modules/account'
import { UpgradeButton } from '@/modules/auth'
import { useProject } from '@/modules/projects'

interface ProcessButtonProps extends ButtonProps {
  isBlocked?: boolean
  validationBehaviour: 'message' | 'hidden' | 'disable-only'
}

export const CreditsMessage = ({
  isBlocked,
  validationBehaviour,
}: ProcessButtonProps) => {
  const project = useProject()
  const account = useAccount()

  if (!isBlocked) return
  if (validationBehaviour !== 'message') return
  if (!isCreditsPlan(account?.planKind)) return
  if (project?.expired) return

  if (isTrialPlan(account?.planKind)) {
    return (
      <span className="text-muted-foreground flex items-center gap-1 text-xs flex-wrap">
        Your trial pages are used up.
        <UpgradeButton
          theme="link"
          size="xs"
          className="h-auto px-0 text-brand underline"
        >
          Upgrade to extract more
        </UpgradeButton>
      </span>
    )
  }

  return (
    <span className="text-muted-foreground flex items-center gap-1 text-xs flex-wrap">
      Statements exceeds available credits.
      <Link
        to="/credits"
        preload="intent"
        className="text-brand underline cursor-pointer"
      >
        Buy more credits
      </Link>
    </span>
  )
}
